import { render } from "./Speciality.vue?vue&type=template&id=c43e09a8"
import script from "./Speciality.vue?vue&type=script&lang=js"
export * from "./Speciality.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__